var _a;
import { generatePromises } from "../generators/generator.promises";
import { GENERATOR_PARAMS } from "./broker.constants";
export var getPaged = (_a = generatePromises(GENERATOR_PARAMS), _a.getPaged), getCount = _a.getCount, getDetail = _a.getDetail;
